var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisualimage4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6225 2.94397C9.79563 2.94397 3.44336 9.29624 3.44336 17.1231C3.44336 24.95 9.79563 31.3023 17.6225 31.3023C25.4494 31.3023 31.8017 24.95 31.8017 17.1231C31.8017 9.29624 25.4494 2.94397 17.6225 2.94397ZM17.7076 27.0486V24.1985H17.6225C15.8076 24.1985 13.9927 23.5038 12.6031 22.1284C11.449 20.973 10.7285 19.4551 10.5632 17.8304C10.3979 16.2058 10.7979 14.5738 11.6956 13.2097L13.2553 14.7694C12.2486 16.6552 12.5038 19.0373 14.0919 20.6254C15.0845 21.6179 16.3889 22.0858 17.6934 22.0575V19.0231L21.7061 23.0358L17.7076 27.0486ZM23.5352 21.0366L21.9755 19.4769C22.9823 17.591 22.727 15.2089 21.139 13.6209C20.6788 13.1567 20.1309 12.7885 19.5273 12.5378C18.9236 12.2871 18.2762 12.1588 17.6225 12.1604H17.5375V15.2089L13.5247 11.2104L17.5375 7.19772V10.0619C19.3807 10.0336 21.2382 10.7 22.642 12.1179C25.0524 14.5283 25.3502 18.2858 23.5352 21.0366Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualimage4);
export default __webpack_public_path__ + "static/media/visualimage4.24a59dc6534249329abeb6ace37f026b.svg";
export { ForwardRef as ReactComponent };